module.exports = __webpack_public_path__ + "img/card-basic-brown-watch.524ab3d0.jpg";